import { useGenericModal } from '..';
import { RepublishModal, RepublishModalProps } from './republish-modal';

export const useRepublishModal = (props: Partial<RepublishModalProps>) => {
  const { modalRef, openModal, closeModal } = useGenericModal();

  const RepublishModalComponent = (
    <RepublishModal {...props} modalRef={modalRef} onClose={closeModal} />
  );

  return {
    modalRef,
    openModal,
    closeModal,
    republishModal: RepublishModalComponent,
  };
};
